import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SyncProvider } from "@/context/SyncContext";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import ClientDetail from "@/pages/ClientDetail";
import Account from "@/pages/Account";
import ProPlan from "@/pages/ProPlan";
import Referral from "@/pages/Referral";
import Admin from "@/pages/Admin";

function Loader() {
  return (
    <div className="min-h-screen bg-tp-green flex items-center justify-center">
      <Loader2 className="animate-spin text-white" size={32} />
    </div>
  );
}

function Protected({ children }) {
  const { tailleur, ready } = useAuth();
  if (!ready) return <Loader />;
  if (!tailleur) return <Navigate to="/bienvenue" replace />;
  return children;
}

function PublicOnly() {
  const { tailleur, ready } = useAuth();
  if (!ready) return <Loader />;
  if (tailleur) {
    const onboarded = localStorage.getItem("tp_onboarded") === "1";
    return <Navigate to={onboarded ? "/" : "/onboarding"} replace />;
  }
  return <Auth />;
}

function Shell() {
  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-tp-bg relative overflow-x-hidden shadow-xl">
      <Routes>
        <Route path="/bienvenue" element={<PublicOnly />} />
        <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/client/:id" element={<Protected><ClientDetail /></Protected>} />
        <Route path="/compte" element={<Protected><Account /></Protected>} />
        <Route path="/pro" element={<Protected><ProPlan /></Protected>} />
        <Route path="/parrainage" element={<Protected><Referral /></Protected>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("tp_ref", ref.trim().toUpperCase());
  }, []);
  return (
    <div className="bg-tp-green min-h-screen">
      <AuthProvider>
        <SyncProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
        </SyncProvider>
      </AuthProvider>
    </div>
  );
}
